import React from 'react'
import { Alert } from 'react-bootstrap'
import { useStateValue } from '../state'

export const AlertBox = () => {
  const [currentState] = useStateValue()

  if (!currentState.message) return null;
  return (
    <React.Fragment>
      <Alert className="alert-danger">{currentState.message}</Alert>
    </React.Fragment>
  )
}
